import { render, staticRenderFns } from "./VipPage.vue?vue&type=template&id=7b35bf24&scoped=true"
import script from "./VipPage.vue?vue&type=script&lang=js"
export * from "./VipPage.vue?vue&type=script&lang=js"
import style0 from "./VipPage.vue?vue&type=style&index=0&id=7b35bf24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b35bf24",
  null
  
)

export default component.exports